import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/footer";
import MobileInfoSection from "./MobileInfoSection";
import Slider from "./Slider";
import Features from "./Features";
import { Helmet } from "react-helmet-async";

const MobileApp = () => {
  const location = useLocation();
  const title = "Mobile Test Management App for QA Anywhere Anytime";
  const description = "Manage and execute mobile tests anywhere with our mobile test management app, ensuring efficient QA, real-time tracking, and seamless test control.";
  return (
    <>
      <Helmet>
        <title>{title}</title>

        <meta
          name="description"
          content={description}
        />

        <meta name="keywords" content="mobile test management app" />

        <link rel="canonical" href="https://frothtestops.com/mobile-app" />

        {/* Open Graph Tags */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content="/images/og-image.jpg" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`https://frothtestops.com${location.pathname}`} />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content="/images/og-image.jpg" />
      </Helmet>
      <div
        className={`fd-main-wrapper ${location.pathname !== "/" ? "page-padding" : ""}`}
      >
        <Header />
        <MobileInfoSection />
        <Slider />
        <Features />
        <Footer />
      </div>
    </>
  );
};

export default MobileApp;
